import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'antd';
import styles from '../../styles/verifyModal.module.scss';
import TextArea from 'antd/es/input/TextArea';
import { fetchUser, verifyUser } from '../../api/user-api';
import PropTypes from 'prop-types';

const UserVerificationModal = ({
  userId,
  onClose,
  visible,
  onVerify,
  verifyLoading,
  verifyDone,
  loadUsers,
}) => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const handleNext = () => setStep(2);
  const handleBack = () => setStep(1);
  const [user, setUser] = useState(null);

  const [form] = Form.useForm();

  useEffect(() => {
    handleBack();

    if (visible) {
      setDone(false);
      setStep(1);
      form.resetFields();
    }
  }, [visible, form]);

  const handleCancelVerif = () => {
    form
      .validateFields()
      .then((values) => {
        handleCancelVerification(values.reason);
      })
      .catch(() => {});
  };

  const handleCancelVerification = async (reason) => {
    setLoading(true);

    const { error } = await verifyUser(userId, false, reason);

    if (error) {
      console.error('Error rejecting user:', error);
      setLoading(false);
      return;
    }

    setLoading(false);
    setDone(true);
    loadUsers();

    setTimeout(() => {
      onClose();
      setDone(false);
      setStep(1);
    }, 1000);
  };

  useEffect(() => {
    const loadUser = async () => {
      const { data, success, message } = await fetchUser(userId);

      if (!success) {
        return;
      }

      setUser(data);
    };

    if (userId) loadUser();
  }, [userId]);

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      getContainer={false}
      title="Verifikacija korisnika"
      footer={
        step === 1
          ? [
              <Button
                key="cancel"
                onClick={handleNext}
                className="btn-tertiary"
              >
                Odbij korisnika
              </Button>,
              <Button
                key="verify"
                onClick={onVerify}
                className="btn-primary"
                style={{ width: '168px' }}
              >
                {verifyLoading ? (
                  <img
                    src="/assets/icons/add.svg"
                    alt="Add Icon"
                    className="animate-spin"
                  />
                ) : verifyDone ? (
                  <img
                    className="check-icon"
                    src="/assets/icons/check.svg"
                    alt="Check Icon"
                  />
                ) : (
                  <span>Verifikuj korisnika</span>
                )}
              </Button>,
            ]
          : [
              <Button
                key="next"
                type="primary"
                className="btn-primary"
                onClick={handleCancelVerif}
                style={{ width: '94px' }}
              >
                {loading ? (
                  <img
                    src="/assets/icons/add.svg"
                    alt="Add Icon"
                    className="animate-spin"
                  />
                ) : done ? (
                  <img
                    src="/assets/icons/check.svg"
                    alt="Check Icon"
                    className="check-icon"
                  />
                ) : (
                  <span>Prosledi</span>
                )}
              </Button>,
            ]
      }
    >
      <div className={styles.userVerifyDetails}>
        {step === 1 ? (
          <div className={styles.userVerifyDetails__content}>
            <div className={styles.userVerifyDetails__content__columns}>
              <div className={styles.userVerifyDetails__item}>
                <span className={styles.userVerifyDetails__item__name}>
                  Naziv firme:
                </span>
                <span className={styles.userVerifyDetails__item__value}>
                  {user?.companyName}
                </span>
              </div>
              <div className={styles.userVerifyDetails__item}>
                <span className={styles.userVerifyDetails__item__name}>
                  PIB:
                </span>
                <span className={styles.userVerifyDetails__item__value}>
                  {user?.pib}
                </span>
              </div>
            </div>
            <div className={styles.userVerifyDetails__item}>
              <span className={styles.userVerifyDetails__item__name}>
                Adresa firme:
              </span>
              <span className={styles.userVerifyDetails__item__value}>
                {user?.companyAddress}
              </span>
            </div>
            <div className={styles.userVerifyDetails__item}>
              <span className={styles.userVerifyDetails__item__name}>
                Ime odgovornog lica:
              </span>
              <span className={styles.userVerifyDetails__item__value}>
                {user?.responsibleName}
              </span>
            </div>
            <div className={styles.userVerifyDetails__item}>
              <span className={styles.userVerifyDetails__item__name}>
                Pozicija odgovornog lica:
              </span>
              <span className={styles.userVerifyDetails__item__value}>
                {user?.responsiblePosition}
              </span>
            </div>
            <div className={styles.userVerifyDetails__item}>
              <span className={styles.userVerifyDetails__item__name}>
                Broj telefona:
              </span>
              <span className={styles.userVerifyDetails__item__value}>
                {user?.phone}
              </span>
            </div>
            <div className={styles.userVerifyDetails__item}>
              <span className={styles.userVerifyDetails__item__name}>
                Email:
              </span>
              <span className={styles.userVerifyDetails__item__value}>
                {user?.email}
              </span>
            </div>
            {/* <div className={styles.userVerifyDetails__item__doc}>
              <div className={styles.userVerifyDetails__item}>
                <span className={styles.userVerifyDetails__item__name}>
                  Dokumentacija:
                </span>
                <span className={styles.userVerifyDetails__item__value}>
                  test.pdf
                </span>
              </div>
              <Button className="btn-tertiary">
                <img src="/assets/icons/download.svg" alt="Download Icon" />
                <span>Preuzmi</span>
              </Button>
            </div> */}
          </div>
        ) : (
          <>
            <div className={styles.userVerifyDetails__reason}>
              <Form form={form}>
                <Form.Item
                  label="Razlog odbijanja"
                  required
                  name="reason"
                  className={styles.userVerifyDetails__reason__item}
                  rules={[
                    { required: true, message: 'Unesite razlog odbijanja' },
                  ]}
                >
                  <TextArea rows={4} />
                </Form.Item>
              </Form>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

UserVerificationModal.propTypes = {
  userId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  onVerify: PropTypes.func.isRequired,
  verifyLoading: PropTypes.bool.isRequired,
  verifyDone: PropTypes.bool.isRequired,
  loadUsers: PropTypes.func.isRequired,
};

export default UserVerificationModal;
